import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import {
  getCategoriesFeaturedAction,
  updateCategoryAction,
} from '../../app/store/actions/categories';

class CategoryFeturedFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: '',
    };
  }

  componentDidMount = async () => {
    this.props.getCategoriesFeatured();
  };

  goBack = () => {
    this.props.back.goBack();
  };

  getCategories = (categories, parentComming) => {
    if (categories !== undefined) {
      return categories.map(category => (
        <React.Fragment key={category.id}>
          <option
            key={category.id}
            value={category.id}
          >
            {category.name}
          </option>
        </React.Fragment>
      ));
    }
  }

  removeCategory = async (category) => {
    try {
      await this.props.updateCategory({
        id: category, isFeatured: false,
      });

      this.setState({
        success: I18n.t('categoryUpdated'), message: '', loadImage: true,
      });

      this.props.getCategoriesFeatured();
    } catch (err) {
      this.setState({ message: I18n.t('errorOcurred'), success: '' });
    } finally {
      this.setState({ loadImage: false, file: '' });
    }
  }

  handleClickRemove = async (category) => {
    await this.removeCategory(category);
  }

  updateCategoryFeatured = async () => {
    const {
      category,
    } = this.state;

    try {
      await this.props.updateCategory({
        id: category, isFeatured: true,
      });

      this.setState({
        success: I18n.t('categoryUpdated'), message: '', loadImage: true,
      });

      this.props.getCategoriesFeatured();
    } catch (err) {
      this.setState({ message: I18n.t('errorOcurred'), success: '' });
    } finally {
      this.setState({ loadImage: false, file: '' });
    }
  };

  render() {
    // this.props.getCategoriesFeatured();
    const { categories, categoriesFeatured } = this.props;
    return (
      <div className="form-main">
        <h4>{I18n.t('Categorias em destaque')}</h4>
        <form>
          <div className="form-group">
            <label htmlFor="categoriesSelect">{I18n.t('category')}</label>
            <select
              className="form-control"
              id="categoriesSelect"
              onChange={e => this.setState({ category: e.target.value })}
            >
              {this.getCategories(categories, categoriesFeatured)}
            </select>
          </div>
          <button type="button" className="btn btn-primary" onClick={() => this.updateCategoryFeatured()}><Translate value="save" /></button>
        </form>
        <table className="table">
          <thead>
            <tr>
              <th>{I18n.t('category')}</th>
              <th>{I18n.t('action')}</th>
            </tr>
          </thead>
          <tbody>
            {categoriesFeatured && categoriesFeatured.map(category => (
              <tr key={category.id}>
                <td>{category.name}</td>
                <td><button className="btn btn-sm btn-danger" onClick={() => this.removeCategory(category.id)}>x</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getCategoriesFeatured: () => dispatch(getCategoriesFeaturedAction()),
  updateCategory: category => dispatch(updateCategoryAction(category)),
});

const mapStateToProps = state => ({
  categories: state.categories.categories,
  categoriesFeatured: state.categories.categoriesFeatured,
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryFeturedFormComponent);
